import { createModel } from '@rematch/core';
import reducers from './reducers';
import state from './state';
import { type RootModel } from './..';

const compare = createModel<RootModel>()({
  name: 'compare',
  reducers,
  state,
});

export default compare;
